import React from 'react';
import MaterialTableRow, {
    TableRowProps as MaterialTableRowProps,
} from '@mui/material/TableRow';
import styled from 'styled-components';

const StyledTableRow = styled(MaterialTableRow)``;

export interface TableRowProps extends MaterialTableRowProps {}

const TableRow: React.FunctionComponent<TableRowProps> = ({ children, ...props }) => {
    return <StyledTableRow {...props}>{children}</StyledTableRow>;
};

export default TableRow;
